import dayjs from 'dayjs'

class DateUtils {
  constructor() {
  }
  formatDate (val, format) {
    let formatStr = format ? format : 'YYYY-MM-DD'
    return dayjs(val).format(formatStr)
  }
  formatDateTime (val, format) {
    let formatStr = format ? format : 'YYYY-MM-DD HH:mm:ss'
    return dayjs(val).format(formatStr)
  }
  addDayDate (value, addDate) {
    return dayjs(value).add(addDate, 'day')
  }
  addMonthDate (value, addDate) {
    return dayjs(value).add(addDate, 'month')
  }
  dateDiff (time1, time2, type) {
    let diffType = type || 'day'
    return Math.abs(dayjs(time1).diff(dayjs(time2), diffType))
  }
  startOfMonth (value) {
    return dayjs(value).startOf('month').format('YYYY-MM-DD')
  }
  endOfMonth (value) {
    return dayjs(value).endOf('month').format('YYYY-MM-DD')
  }
}

export default new DateUtils()



// WEBPACK FOOTER //
// ./src/utils/date.js